import { render, staticRenderFns } from "./LicenseCard.vue?vue&type=template&id=9b0590d8&scoped=true&"
import script from "./LicenseCard.vue?vue&type=script&lang=js&"
export * from "./LicenseCard.vue?vue&type=script&lang=js&"
import style0 from "./LicenseCard.vue?vue&type=style&index=0&id=9b0590d8&prod&lang=css&"
import style1 from "./LicenseCard.vue?vue&type=style&index=1&id=9b0590d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0590d8",
  null
  
)

export default component.exports